// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/@master/webinfra-frontend-components/src/components/DetailsPage/DetailsPage.less
// module id = 834
// module chunks = 0